import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { useForm, Controller } from "react-hook-form";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import withServices from "../hocs/withServices";
import { MuiTelInput } from "mui-tel-input";

function Registration({ services }) {
  const history = useHistory();
  const {
    register,
    handleSubmit,
    control,
  } = useForm({});

  const [errorMessage, setErrorMessage] = useState("");

  const isCyrillicOrKazakhOnly = (text) => /^[\p{Script=Cyrillic}әғқңөұүһіА-Яа-яЁё\s]+$/u.test(text);

  const handleCyrillicKeyPress = (event) => {
    if (!/[\p{Script=Cyrillic}әғқңөұүһіА-Яа-яЁё\s]/u.test(event.key)) {
      event.preventDefault();
    }
  };

  const handleCyrillicPaste = (event) => {
    const paste = (event.clipboardData || window.clipboardData).getData("text");
    if (!isCyrillicOrKazakhOnly(paste)) {
      event.preventDefault();
    }
  };

  const filterCyrillicInput = (event) => {
    const value = event.target.value;
    const cyrillicOnly = value.replace(/[^\p{Script=Cyrillic}әғқңөұүһіА-Яа-яЁё\s]/gu, "");
    if (value !== cyrillicOnly) {
      event.target.value = cyrillicOnly;
    }
  };
  
  const handleEnglish = (event) => {
    // Disallow English letters
    if (!/[\p{Script=Latin}\s]/u.test(event.key)) {
      event.preventDefault();
    }
  };


  const onSubmit = (data) => {
    if (data.password === data.confirmPassword) {
      data.phoneNumber = "+" + data.phoneNumber?.replace(/\D/g, "");
      services.auth
        .registration(data)
        .then(() => {
          alert("На вашу почту выслана ссылка для активации аккаунта");
          history.push("/login");
        })
        .catch((error) => setErrorMessage(error));
    } else {
      setErrorMessage("Пароли не совпадают");
    }
  };

  let useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: "100%", // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    fioInfo: {
      margin: "0 0 10px 10px",
      color: "#6b6969",
    },
  }));
  const classes = useStyles();

  return (
    <div>
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <div className={classes.paper}>
          <div>
            <img
              src="aitu-logo.png"
              alt="logo"
            />
          </div>
          <Typography component="h1" variant="h5">
            Регистрация
          </Typography>

          {errorMessage && (
            <Typography variant="body1" color="error">
              {errorMessage}
            </Typography>
          )}

          <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
            <Typography className={classes.fioInfo}>
              ФИО (Как в удостоверении личности)
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
              <TextField
                {...register("name")}
                variant="outlined"
                required
                fullWidth
                id="name"
                label="Имя"
                onKeyPress={handleCyrillicKeyPress}
                onPaste={handleCyrillicPaste}
                onInput={filterCyrillicInput}
              />
              </Grid>
              <Grid item xs={12} sm={6}>
              <TextField
                {...register("surname")}
                variant="outlined"
                required
                fullWidth
                id="lastName"
                label="Фамилия"
                onKeyPress={handleCyrillicKeyPress}
                onPaste={handleCyrillicPaste}
                onInput={filterCyrillicInput}
              />
              </Grid>
              <Grid item xs={12}>
              <TextField
                {...register("patronymic")}
                variant="outlined"
                fullWidth
                id="patronymic"
                label="Отчество"
                name="patronymic"
                autoComplete="patronymic"
                onKeyPress={handleCyrillicKeyPress}
                onPaste={handleCyrillicPaste}
                onInput={filterCyrillicInput}
              />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  {...register("nameInLatin")}
                  variant="outlined"
                  required
                  fullWidth
                  id="nameInLatin"
                  label="Имя(транслитом)"
                  onKeyPress={handleEnglish}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  {...register("surnameInLatin")}
                  variant="outlined"
                  required
                  fullWidth
                  id="surnameInLatin"
                  label="Фамилия(транслитом)"
                  onKeyPress={handleEnglish}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  {...register("email")}
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  label="Почта"
                  name="email"
                  autoComplete="email"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  {...register("password")}
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  label="Пароль"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  {...register("confirmPassword")}
                  variant="outlined"
                  required
                  fullWidth
                  name="confirmPassword"
                  label="Подтверждение пароля"
                  type="password"
                  id="confirmPassword"
                  autoComplete="current-password"
                />
              </Grid>

              <Grid item xs={12}>
                <Controller
                  name="phoneNumber"
                  control={control}
                  defaultValue=""
                  render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <MuiTelInput
                      defaultCountry="KZ"
                      onChange={(newValue, info) => {
                        if (info?.countryCode === "KZ" && newValue.replaceAll(" ", "").length >= 13) {
                          return;
                        }
                        onChange(newValue);
                      }}
                      value={value}
                      error={!!error}
                      helperText={error ? error.message : null}
                      fullWidth
                      forceCallingCode
                    />
                  )}
                  rules={{ required: "Phone number is required" }}
                />
              </Grid>
              <Grid item xs={12}></Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox value="allowExtraEmails" color="primary" />
                  }
                  label="Я хочу получать информацию о поступлении, обучении, грантах и скидках"
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Sign Up
            </Button>
            <Grid container justify="flex-end">
              <Grid item>
                <NavLink to={"/login"} className="nav-link" variant="body2">
                  Уже имеется аккаунт? Войти
                </NavLink>
              </Grid>
            </Grid>
          </form>
        </div>
        <Box mt={5}>
          <Copyright />
        </Box>
      </Container>
    </div>
  );
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://astanait.edu.kz/">
        Astana IT University
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default withServices()(Registration);
